<div class="review-and-pay-actions" [attr.aria-busy]="checkoutActive() ? 'true' : null">
  @if (checkoutActive()) {
    <output class="visually-hidden" data-testid="review-proceed-processing-status">
      {{ 'createShipment.reviewAndPay.actions.proceedLoading' | translate }}
    </output>
  }

  <puro-button
    type="button"
    variant="secondary"
    size="large"
    class="review-and-pay-actions__back"
    data-testid="review-back"
    [disabled]="checkoutActive()"
    (buttonClick)="onBack()"
  >
    {{ 'createShipment.reviewAndPay.actions.back' | translate }}
  </puro-button>

  <puro-button
    type="button"
    variant="secondary"
    size="large"
    class="review-and-pay-actions__cancel"
    data-testid="review-cancel-shipment"
    [disabled]="checkoutActive()"
    (buttonClick)="onCancel()"
  >
    {{ 'createShipment.reviewAndPay.actions.cancel' | translate }}
  </puro-button>

  <puro-button
    type="button"
    variant="primary"
    size="large"
    class="review-and-pay-actions__proceed"
    data-testid="review-proceed-to-payment"
    [disabled]="checkoutActive()"
    [loading]="checkoutActive()"
    (buttonClick)="onProceed()"
  >
    {{ 'createShipment.reviewAndPay.actions.proceed' | translate }}
  </puro-button>
</div>
